import { ApiError } from '@/lib/api'
import { hasFieldErrors } from '@/lib/contacts/errors'

export function eventApiMessage(error: Error) {
  if (error instanceof ApiError && hasFieldErrors(error.body)) {
    return Object.values(error.body.errors).flat().join('. ')
  }

  return error.message || 'The Event could not be changed.'
}
